import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
import { ShieldCheck } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-20 md:py-32 px-4 bg-white relative overflow-hidden" data-id="element-116">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-117">
        <FadeIn data-id="element-118">
          <div className="bg-brand-lavender rounded-[2.5rem] p-8 md:p-16 text-center text-white shadow-2xl relative overflow-hidden" data-id="element-119">
            {/* Decorative background circles */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full translate-x-1/2 -translate-y-1/2" data-id="element-120" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-white opacity-5 rounded-full -translate-x-1/2 translate-y-1/2" data-id="element-121" />

            <div className="relative z-10" data-id="element-122">
              <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-123">
                Recupera el control de tu cuerpo hoy mismo.
              </h2>
              <p className="text-lg md:text-xl text-white/90 mb-10 max-w-2xl mx-auto" data-id="element-124">
                No permitas que una noche más de sudor y cansancio te robe tu
                vitalidad. Obtén el sistema completo "Las 7 Claves para la
                Menopausia 40+" por un pago único.
              </p>

              <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 mb-10 border border-white/20 inline-block w-full max-w-md" data-id="element-125">
                <p className="text-white/80 text-sm uppercase tracking-wider font-semibold mb-2" data-id="element-126">
                  Precio Especial
                </p>
                <div className="flex items-center justify-center gap-2 mb-4" data-id="element-127">
                  <span className="text-6xl font-bold" data-id="element-128">$17</span>
                  <span className="text-2xl font-medium text-white/80 mt-4" data-id="element-129">
                    USD
                  </span>
                </div>
                <p className="text-white/90 text-sm" data-id="element-130">
                  Acceso de por vida • Pago único
                </p>
              </div>

              <a href="https://vitalizateahora.com/cart/51916911804647:1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full md:w-auto text-xl px-10 py-5 mb-6 font-medium rounded-full transition-all duration-300 shadow-xl hover:shadow-2xl bg-brand-sage text-white hover:bg-[#7A8A76] cursor-pointer no-underline" data-id="element-131">
                ¡SÍ, QUIERO MI PROTOCOLO AHORA!
              </a>

              <div className="flex items-center justify-center gap-2 text-white/80 text-sm" data-id="element-132">
                <ShieldCheck className="w-5 h-5" data-id="element-133" />
                <span data-id="element-134">Compra segura con entrega inmediata.</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}